import { IHelpStyles } from './Help.types';
import { linkPadding } from '../constants';

export const helpStyles: IHelpStyles = {
  main: {
    display: 'flex',
    flexDirection: 'column'
  },
  link: {
    padding: `${linkPadding}px`
  }
};
